module.exports = __webpack_public_path__ + "img/10_40.e5335d6f.png";